import { Input, Link } from "@heroui/react";
import { type Address, type Hash, isAddress, isHash } from "viem";

export function ManualClaimWithdrawForm({
  l1TokenAddress,
  messageHash,
  l2BlockNumber,
  witness,
  message,
  l2WithdrawData,
  setL1TokenAddress,
  setMessageHash,
  setL2BlockNumber,
  setWitness,
  setMessage,
  setL2WithdrawData,
}: {
  l1TokenAddress: Address | undefined;
  messageHash: Hash | undefined;
  l2BlockNumber: number | undefined;
  witness: Hash | undefined;
  message: Hash | undefined;
  l2WithdrawData: Hash | undefined;
  setL1TokenAddress: (address: Address | undefined) => void;
  setMessageHash: (hash: Hash | undefined) => void;
  setL2BlockNumber: (blockNumber: number | undefined) => void;
  setWitness: (witness: Hash | undefined) => void;
  setMessage: (message: Hash | undefined) => void;
  setL2WithdrawData: (data: Hash | undefined) => void;
}) {
  return (
    <>
      <div className="flex items-center justify-between w-full">
        <div className="font-semibold">L1 Parameters</div>
        <Link href="#" isExternal showAnchorIcon>
          Ethereum explorer
        </Link>
      </div>
      <Input
        label="L1 token address"
        name="l1TokenAddress"
        variant="flat"
        validationBehavior="native"
        validate={(value) => {
          if (!isAddress(value)) return "Invalid address";
        }}
        value={l1TokenAddress}
        onValueChange={(value) => setL1TokenAddress(value as Address)}
        classNames={{
          inputWrapper: "bg-[#3F6784] group-data-[hover=true]:bg-[#487292] group-data-[focus=true]:bg-[#3F6784]",
        }}
      />
      <Input
        label="L2 to L1 message hash"
        name="messageHash"
        variant="flat"
        validationBehavior="native"
        validate={(value) => {
          if (!isHash(value)) return "Invalid value";
        }}
        value={messageHash}
        onValueChange={(value) => setMessageHash(value as Hash)}
        classNames={{
          inputWrapper: "bg-[#3F6784] group-data-[hover=true]:bg-[#487292] group-data-[focus=true]:bg-[#3F6784]",
        }}
      />
      <div className="flex items-center justify-between w-full">
        <div className="font-semibold">L2 Parameters</div>
        <Link href="#" isExternal showAnchorIcon>
          Aztec explorer
        </Link>
      </div>
      <Input
        label="L2 block number"
        name="l2BlockNumber"
        variant="flat"
        validationBehavior="native"
        validate={(value) => {
          if (value.length === 0 || !Number.isFinite(+value)) return "Invalid number";
        }}
        value={l2BlockNumber?.toString()}
        onValueChange={(value) => setL2BlockNumber(Number(value))}
        classNames={{
          inputWrapper: "bg-[#3F6784] group-data-[hover=true]:bg-[#487292] group-data-[focus=true]:bg-[#3F6784]",
        }}
      />
      <Input
        label="Witness"
        name="witness"
        variant="flat"
        validationBehavior="native"
        validate={(value) => {
          if (!isHash(value)) return "Invalid value";
        }}
        value={witness}
        onValueChange={(value) => setWitness(value as Hash)}
        classNames={{
          inputWrapper: "bg-[#3F6784] group-data-[hover=true]:bg-[#487292] group-data-[focus=true]:bg-[#3F6784]",
        }}
      />
      <Input
        label="Message"
        name="message"
        variant="flat"
        validationBehavior="native"
        validate={(value) => {
          if (!isHash(value)) return "Invalid value";
        }}
        value={message}
        onValueChange={(value) => setMessage(value as Hash)}
        classNames={{
          inputWrapper: "bg-[#3F6784] group-data-[hover=true]:bg-[#487292] group-data-[focus=true]:bg-[#3F6784]",
        }}
      />
      <Input
        label="L2 withdraw data"
        name="l2WithdrawData"
        variant="flat"
        validationBehavior="native"
        validate={(value) => {
          if (!isHash(value)) return "Invalid value";
        }}
        value={l2WithdrawData}
        onValueChange={(value) => setL2WithdrawData(value as Hash)}
        classNames={{
          inputWrapper: "bg-[#3F6784] group-data-[hover=true]:bg-[#487292] group-data-[focus=true]:bg-[#3F6784]",
        }}
      />
    </>
  );
}
